var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9266 22.1501C17.5219 22.1501 22.0601 17.6068 22.0601 11.9996C22.0601 6.39249 17.5219 1.84923 11.9266 1.84923C6.33125 1.84923 1.7931 6.39249 1.7931 11.9996C1.7931 17.6068 6.33125 22.1501 11.9266 22.1501ZM11.9266 23.9446C18.5134 23.9446 23.8532 18.5967 23.8532 11.9996C23.8532 5.40263 18.5134 0.0546875 11.9266 0.0546875C5.33971 0.0546875 0 5.40263 0 11.9996C0 18.5967 5.33971 23.9446 11.9266 23.9446Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6443 6.19863L10.2166 9.97145C9.85766 10.2771 9.52269 10.8584 9.43722 11.3235L8.38876 17.0495C8.31148 17.4708 8.45388 17.706 8.58694 17.829C8.75006 17.9799 8.97364 18.0314 9.20044 17.9706C9.33286 17.935 9.46644 17.86 9.59719 17.7485L14.0245 13.9758C14.3839 13.6698 14.7189 13.0886 14.8038 12.6242L15.8526 6.89774C15.9299 6.47637 15.7876 6.24141 15.6545 6.11844C15.3965 5.87966 14.9993 5.89552 14.6443 6.19863ZM13.799 12.4397C13.7564 12.6741 13.5444 13.0418 13.3627 13.1964L9.53563 16.4575L10.4418 11.5083C10.485 11.2732 10.6973 10.905 10.8784 10.7505L14.7056 7.48932L13.799 12.4397Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6661 12.6435C12.1745 12.9363 12.8247 12.7618 13.1184 12.2538C13.4116 11.7452 13.2376 11.0946 12.7298 10.8011C12.2212 10.5076 11.571 10.6821 11.2774 11.1908C10.9838 11.6994 11.1578 12.35 11.6661 12.6435Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1ea971d8483850e2dd518cf7d0174a99.svg";
export { ForwardRef as ReactComponent };